import Components from "slotworks/components/components";
import Idle from "slotworks/state-machine/standard/states/idle";
import Timer from "slotworks/utils/timer";
import HarleyComponents from "components/components";
import RevolverSettings from "model/revolver-settings";
import soundManager from "slotworks/sound/sound-manager";

export default class HarleyIdle extends Idle {

    public static MIN_IDLE_TIME = 2000;

    public static IDLE_TIME = 6000;

    private symbolTimer: number;
    private musicTimer: number;

    public onEnter() {
        HarleyComponents.bonusBuyButton.setEnabled(true);
        this.setTimer();

        const time = Date.now() - RevolverSettings.lastWinTime;
        if(RevolverSettings.winCount == 0 || time > 10000) {
            soundManager.customEvent("base_music");
            RevolverSettings.winCount = 0;
        } else {
            this.musicTimer = Timer.setTimeout(() => {
                soundManager.customEvent("base_music");
                RevolverSettings.winCount = 0;
            }, 10000 - time);
        }

        super.onEnter();
    }

    public onExit(): void {
        Timer.clearTimeout(this.musicTimer);
        Timer.clearTimeout(this.symbolTimer);
        super.onExit();
    }

    private nextTimer = () => {
        const x = Math.floor(Math.random() * 5);
        const y = Math.floor(Math.random() * 3);
        const symbol = Components.matrix.getSymbol(x, y);
        symbol.stop().execute();
        this.setTimer();
    }

    private setTimer = () => {
        this.symbolTimer = Timer.setTimeout(this.nextTimer, HarleyIdle.MIN_IDLE_TIME + Math.random() * HarleyIdle.IDLE_TIME);
    }

}